import $ from 'jquery';
import _ from 'underscore';
import StateManager from '../scuba/StateManager';

/* -------------------------
    INIT
------------------------- */

$(window).on(StateManager.CONTENT_READY, function(event, node) {
    $(node).find('.js-authors').each(function(i, el) {
        new Authors(el);
    });
});


/* --------------------------------------------------

    CLASS

-------------------------------------------------- */

function Authors() {
    this.initialize.apply(this, arguments);
}

$.extend(Authors.prototype, {

    initialize: function(el) {
      var self = this;
      self.uid = _.uniqueId('scuba-');
      self.$el = $(el);
      self.$sectionContent = self.$el.closest('.js-scuba__content');

      self.adjustHeight();


      self.$sectionContent.on("widthChanged", self.adjustHeight.bind(self));

      self.$el.on('click', '.js-authors__toggle', function(event) {
        self.$el.toggleClass('is-extended');
        self.adjustHeight.bind(self)();
        event.preventDefault();
      });

    },

    adjustHeight: function() {
      var self = this;
      var $source = self.$el.hasClass('is-extended') ? self.$el.find(".js-authors__toggle").last() : self.$el.find(".js-authors__toggle").first();
      self.$el.height($source.height());
    },

});



// WEBPACK FOOTER //
// ./scripts/components/Authors.js